import { AppRoutes } from 'containers/App/routes';
import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';

export const databaseConsoleRoot = 'databaseConsole';
export const databaseConsoleOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${databaseConsoleRoot}`;
